import { styled } from '@compiled/react';
import { FieldWrapper } from '@atlassian/jira-issue-field-heading';

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ReadOnlyFieldWrapper = styled(FieldWrapper)({
	alignItems: 'center',
});
